module.exports = __webpack_public_path__ + "static/img/stage-warn.41e48a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/stage-warn.png
// module id = pyaV
// module chunks = 58